'use strict';

function CompanyPublicationCompanyInvestigationCtrl(
  $scope,
  $stateParams,
  $filter,
  $translate,
  growl,
  config,
  $modal,
  CompanyGroupService,
  CompanyPublicationCompanyInvestigationService,
  CompanyUserService) {

  $scope.editInvestigationInfor = function(investigationInfor){
    $scope.publicationAccountToggle = false;
    if(investigationInfor){
      $scope.newInvestigationInfor = investigationInfor;
    }else{
      $scope.newInvestigationInfor = {
        type: 'REDOGO',
        partner: '',
        periodUp: '14 days',
        telephoneMode: false,
        personlightMode: false,
        varnadDate: new Date(),
        content: '',
        extra: {
          selectdPart1: [],
          selectdPart2: []
        }
      };
    }
    if(!$scope.newInvestigationInfor.opened){
      if(!$scope.newInvestigationInfor.extra.listUserPart1){
        $scope.newInvestigationInfor.extra.listUserPart1 = [];
      }
      $scope.newInvestigationInfor.extra.listUserPart1 = $scope.part1Users.concat($scope.newInvestigationInfor.extra.listUserPart1);
    }
    $scope.newInvestigationInfor.opened = true;
    setTimeout(function(){
      $scope.$apply(function(){
        $scope.publicationAccountToggle = true;
      });
    }, 1);
  };

  $scope.editInvestigationSanmanInfor = function(investigationInfor){
    $scope.publicationSummaryToggle = false;
    if(investigationInfor){
      $scope.newInvestigationSanmanInfor = investigationInfor;
    }else{
      $scope.newInvestigationSanmanInfor = {
        type: 'SANMAN',
        partner: '',
        periodUp: '14 days',
        telephoneMode: false,
        personlightMode: false,
        varnadDate: new Date(),
        content: '',
        extra: {
          selectdPart1: []
        }
      };
    }
    setTimeout(function(){
      $scope.$apply(function(){
        $scope.publicationSummaryToggle = true;
      });
    }, 1);
  };

  $scope.closeInvestigationInfor = function(){
    $scope.publicationAccountToggle = false;
  };

  $scope.closeInvestigationSanmanInfor = function(){
    $scope.publicationSummaryToggle = false;
  };

  $scope.doneSign = function(investigation){
    $scope.investigation.beslutSign = investigation.signModal;
  };

  $scope.onOpenModal = function(investigationO){
    var modalSign = $modal({
      scope: $scope,
      controller: ['$scope', function($scope){
        $scope.doneSignature = function(investigation){
          $scope.doneSign(investigation);
          $scope.toggleSignModal = false;
        };
        $scope.toggleSignModal = true;
        $scope.investigation.signModal = investigationO.beslutSign;
      }],
      templateUrl: 'partials/company/publications/detail/latest/investigation-tab/signature-modal.html',
      show: false
    });
    modalSign.$promise.then(modalSign.show);
  };

  $scope.addInvesUser = function(invesUser){
    invesUser.newUser.publication = $scope.publication;
    CompanyPublicationCompanyInvestigationService.addUsersInvestigation({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId
    }, invesUser.newUser, function(resp){
      growl.addSuccessMessage($translate.instant('investigation.added-user-success'));
      if(invesUser.newUser.type !== 'BETSLUT'){
        $scope.invesUsers[$scope.invesUsers.indexOf(invesUser)].users.push(resp);
        $scope.invesUsers[$scope.invesUsers.indexOf(invesUser)].newUser = {};
        if($scope.invesUsers[2].users.length > 0 && $scope.invesUsers[3].users.length > 0 && $scope.investigation.partnerAddress && $scope.investigation.invesDate){
          $scope.investigationSteps[0].success = true;
        }
        var inCurrentUser = $scope.invesUsers[2].users.filter(function(item){
          return item.email === $scope.currentUser.email;
        })[0];
        if($scope.investigationInfors.length > 0 && inCurrentUser){
          $scope.investigationSteps[1].success = true;
        }
      }else{
        $scope.invesUsersBetslut.push(resp);
      }

      var tempUsers = $scope.invesUsers[0].users.concat($scope.invesUsers[1].users);
      $scope.part1Users = tempUsers.filter(function(elem, index, self) {
        var item = tempUsers.filter(function(user){
          return user.email === elem.email;
        })[0];
        return index === self.indexOf(item);
      });

      var temp2Users = $scope.invesUsers[2].users.concat($scope.invesUsers[3].users);
      $scope.part2Users = temp2Users.filter(function(elem, index, self) {
        var item = temp2Users.filter(function(user){
          return user.email === elem.email;
        })[0];
        return index === self.indexOf(item);
      });
    }, function(){
      growl.addErrorMessage($translate.instant('investigation.added-user-failure'));
    });
  };

  $scope.addSelectedPart = function(user, part){
    if(part === 1){
      $scope.newInvestigationInfor.extra.selectdPart1 = [];
      $scope.newInvestigationInfor.extra.selectdPart1.push(user);
    }
    if(part === 2){
      $scope.newInvestigationInfor.extra.selectdPart2 = [];
      $scope.newInvestigationInfor.extra.selectdPart2.push(user);
    }
  };

  $scope.addSelectedPartSanman = function(user){
    if(!$scope.newInvestigationSanmanInfor.extra || ($scope.newInvestigationSanmanInfor.extra && !$scope.newInvestigationSanmanInfor.extra.selectdPart1)){
      $scope.newInvestigationSanmanInfor.extra.selectdPart1 = [];
    }
    var part1 = $scope.newInvestigationSanmanInfor.extra.selectdPart1.filter(function(item){
      return item.email === user.email;
    })[0];
    if($scope.newInvestigationSanmanInfor.extra.selectdPart1.indexOf(part1) === -1){
      $scope.newInvestigationSanmanInfor.extra.selectdPart1.push(user);
    }else{
      $scope.newInvestigationSanmanInfor.extra.selectdPart1.splice($scope.newInvestigationSanmanInfor.extra.selectdPart1.indexOf(part1), 1);
    }
  };

  $scope.addSelectedPartAction = function(user, index){
    var part1 = $scope.investigationAtgardInfors[index].extra.selectdPart1.filter(function(item){
      return item.email === user.email;
    })[0];
    if($scope.investigationAtgardInfors[index].extra.selectdPart1.indexOf(part1) === -1){
      $scope.investigationAtgardInfors[index].extra.selectdPart1.push(user);
    }
    $scope.nonInvestigationUsers.splice($scope.nonInvestigationUsers.indexOf(user), 1);
  };

  $scope.removeSelectedPartAction = function(user, index){
    $scope.investigationAtgardInfors[index].extra.selectdPart1.splice($scope.investigationAtgardInfors[index].extra.selectdPart1.indexOf(user), 1);
  };

  $scope.nonInvestigationUsers = [];
  $scope.queryUsers = function(text, index) {
    if(!$scope.investigationAtgardInfors[index].extra.selectdPart1){
      $scope.investigationAtgardInfors[index].extra.selectdPart1 = [];
    }
    CompanyUserService.query({
      companyId: $stateParams.companyId,
      q: text,
      limit: 10
    }).$promise.then(function(u){
      $scope.nonInvestigationUsers = u.filter(function(u){
        return !$scope.investigationAtgardInfors[index].extra.selectdPart1.some(function(investigationUser){
          return investigationUser.id === u.id;
        });
      });
    });
  };

  $scope.deleteInvesUser = function(invesUser, user){
    if(user.type  !== 'BETSLUT'){
      var indexInvesUser = $scope.invesUsers.indexOf(invesUser);
    }
    CompanyPublicationCompanyInvestigationService.deleteUsersInvestigation({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      invesUserId: user.id
    }, function(){
      growl.addSuccessMessage($translate.instant('customer-portals.remove-member-success'));
      if(user.type  !== 'BETSLUT'){
        $scope.invesUsers[indexInvesUser].users.splice($scope.invesUsers[indexInvesUser].users.indexOf(user), 1);
        if($scope.invesUsers[2].users.length === 0 || $scope.invesUsers[3].users.length === 0){
          $scope.investigationSteps[0].success = false;
        }
        var inCurrentUser = $scope.invesUsers[2].users.filter(function(item){
          return item.email === $scope.currentUser.email;
        })[0];
        if($scope.investigationInfors.length === 0 || !inCurrentUser){
          $scope.investigationSteps[1].success = false;
        }
      }else{
        $scope.invesUsersBetslut.splice($scope.invesUsersBetslut.indexOf(user), 1);
      }
    }, function(){
      growl.addErrorMessage($translate.instant('customer-portals.remove-member-failure'));
    });
  };

  $scope.searchUsers = function(filter) {
    CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 10}).$promise.then(function(users) {
      $scope.users = users;
    });
  };

  $scope.saveInvestigationInfor = function(investigationInfor){
    if(!investigationInfor.id){
      CompanyPublicationCompanyInvestigationService.addInvestigationInfor({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId
      }, investigationInfor, function(resp){
        growl.addSuccessMessage($translate.instant('investigation.save-investigation-infor-success'));
        resp.createdBy.email = $scope.currentUser.email;
        if(investigationInfor.type === 'REDOGO'){
          $scope.investigationInfors.push(resp);
          $scope.investigationSteps[1].success = true;
        }else{
          if(investigationInfor.type === 'SANMAN'){
            $scope.investigationSanmanInfors.push(resp);
            $scope.investigationSteps[2].success = true;
          }else{
            if(investigationInfor.type === 'BETSLUT'){
              $scope.investigationBetslutInfors = resp;
            }else{
              $scope.investigationAtgardInfors.push(resp);
            }
          }
        }
      }, function(){
        growl.addErrorMessage($translate.instant('investigation.save-investigation-infor-failure'));
      });
    }else{
      CompanyPublicationCompanyInvestigationService.updateInvestigationInfor({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        investigationInforId: investigationInfor.id
      }, investigationInfor, function(){
        growl.addSuccessMessage($translate.instant('investigation.save-investigation-infor-success'));
        if(investigationInfor.type === 'ATGARD'){
          if(investigationInfor.followUpDate && investigationInfor.followUpContent){
            $scope.investigationAtgardInfors[$scope.investigationAtgardInfors.indexOf(investigationInfor)].savedFollowUp = true;
          }else{
            $scope.investigationAtgardInfors[$scope.investigationAtgardInfors.indexOf(investigationInfor)].savedFollowUp = false;
          }
        }
      }, function(){
        growl.addErrorMessage($translate.instant('investigation.save-investigation-infor-failure'));
      });
    }
  };

  $scope.deleteInvestigationInfor = function(investigationInfor){
    CompanyPublicationCompanyInvestigationService.deleteInvestigationInfor({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      investigationInforId: investigationInfor.id
    }, function(){
      growl.addSuccessMessage($translate.instant('investigation.remove-investigation-infor-success'));
      if(investigationInfor.type === 'REDOGO'){
          $scope.investigationInfors.splice($scope.investigationInfors.indexOf(investigationInfor), 1);
          if($scope.investigationInfors.length === 0){
            $scope.investigationSteps[1].success = false;
          }
        }else{
          $scope.investigationSanmanInfors.splice($scope.investigationSanmanInfors.indexOf(investigationInfor), 1);
          if($scope.investigationSanmanInfors.length === 0){
            $scope.investigationSteps[2].success = false;
          }
        }
    }, function(){
      growl.addErrorMessage($translate.instant('investigation.remove-investigation-infor-failure'));
    });
  };

  $scope.downloadInvestigation = function() {
    CompanyPublicationCompanyInvestigationService.decisionPdf({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId
    }, {}, function() {
      var elm = angular.element(document.querySelector('body'));
      var iFrame = elm.find('#downloadWindow');
      if (!(iFrame && iFrame.length > 0)) {
        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
        elm.append(iFrame);
      }

      iFrame.attr('src', config.apiBase + '/files/' + $stateParams.publicationId + '?download=true&fileName=decision.pdf');

      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      if (true === iOS) {
        window.open(config.apiBase + '/files/' + $stateParams.publicationId + '?download=true&fileName=decision.pdf', '_self');
        return;
      }
    });
  };

  $scope.downloadDecisionDone = function() {
    CompanyPublicationCompanyInvestigationService.decisionDonePdf({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId
    }, {}, function() {
      var elm = angular.element(document.querySelector('body'));
      var iFrame = elm.find('#downloadDecisionDone');
      if (!(iFrame && iFrame.length > 0)) {
        iFrame = angular.element("<iframe id='downloadDecisionDone' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
        elm.append(iFrame);
      }

      iFrame.attr('src', config.apiBase + '/files/' + $stateParams.publicationId + '?download=true&fileName=decision-done.pdf');

      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      if (true === iOS) {
        window.open(config.apiBase + '/files/' + $stateParams.publicationId + '?download=true&fileName=decision-done.pdf', '_self');
        return;
      }
    });
  };

  if (!$scope.publication.groups) {
    $scope.publication.groups = [];
  }

  CompanyGroupService.query({companyId: $stateParams.companyId, all: true, type: 'VISIBLE'}).$promise.then(function(groups) {
    $scope.searchResult = groups;
  });

  $scope.add = function(group) {
    if($scope.publication.groups.indexOf(group.id) > -1){
      $scope.publication.groups.splice($scope.publication.groups.indexOf(group.id), 1);
    }else{
      $scope.publication.groups.push(group.id);
    }
  };

  $scope.remove = function(index) {
    $scope.publication.groups.splice(index, 1);
  };
}

angular.module('dokiv')
  .controller('CompanyPublicationCompanyInvestigationCtrl', [
    '$scope',
    '$stateParams',
    '$filter',
    '$translate',
    'growl',
    'config',
    '$modal',
    'CompanyGroupService',
    'CompanyPublicationCompanyInvestigationService',
    'CompanyUserService',
    CompanyPublicationCompanyInvestigationCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/investigation/CompanyPublicationCompanyInvestigationCtrl.js
// module id = 400
// module chunks = 0